module.exports = __webpack_public_path__ + "img/pumas-logo-icon.94afc033.png";